import React from 'react'
import { DataGridPro } from '@mui/x-data-grid-pro';

const NoticeFileList = ({
    columns,
    files,
    error,
    loading
}) => {
  return (
    <div style={{ display: 'flex', height: '200px' }}>
    <div style={{ flexGrow: 1 }}>
      <DataGridPro
        rows={files ? files : []}
        columns={columns}
      />
    </div>
  </div>
  )
}

export default NoticeFileList